"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { getLinkBehavior } from "../../../utils/targetLinkBehavior/getLinkBehavior.js";
import { MarkdownRenderer } from "@nxt-costco-com/forge-components";
import { useCheckScreen } from "../../../hooks/useCheckScreen/index.js";
import { ORIENTATION_MAP } from "./constants.js";
import { TilesContainer, LinkTile, TileImage, TileTextContainer, TitleText, SubtitleText, Tile } from "./styles.js";
const FeatureTilesSection = ({
  data,
  globalTextColor,
  viewName
}) => {
  const { feature_tiles, body_section_config } = data;
  const { isBiggerDesktop, isDesktop, isTablet, isMobile } = useCheckScreen();
  if (!feature_tiles || feature_tiles.length <= 0) {
    return null;
  }
  const {
    small_viewport,
    medium_viewport,
    large_viewport,
    extra_large_viewport
  } = body_section_config.feature_tiles_orientation;
  let tileOrientation = ORIENTATION_MAP[small_viewport];
  if (isBiggerDesktop) {
    tileOrientation = ORIENTATION_MAP[extra_large_viewport];
  } else if (isDesktop) {
    tileOrientation = ORIENTATION_MAP[large_viewport];
  } else if (isTablet) {
    tileOrientation = ORIENTATION_MAP[medium_viewport];
  } else if (isMobile) {
    tileOrientation = ORIENTATION_MAP[small_viewport];
  }
  return /* @__PURE__ */ jsx(
    TilesContainer,
    {
      "data-testid": `${viewName}-tiles`,
      tileOrientation,
      children: feature_tiles.map((tile, index) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const { target } = getLinkBehavior(
          tile == null ? void 0 : tile.tile_url.external_site,
          tile == null ? void 0 : tile.tile_url.same_tab_domain
        );
        const { background_color, text_color } = tile.text_and_background_color;
        if (tile.tile_url && tile.tile_url.url) {
          return /* @__PURE__ */ jsxs(
            LinkTile,
            {
              background: background_color == null ? void 0 : background_color.hex,
              borderColor: (_a = tile.border_color) == null ? void 0 : _a.hex,
              hasExternalLinkWarning: tile.tile_url.external_site,
              href: tile.tile_url.url,
              target,
              children: [
                /* @__PURE__ */ jsx(
                  TileImage,
                  {
                    src: (_d = (_c = (_b = tile == null ? void 0 : tile.feature_icon) == null ? void 0 : _b.image) == null ? void 0 : _c[0]) == null ? void 0 : _d.url,
                    alt: (_e = tile == null ? void 0 : tile.feature_icon) == null ? void 0 : _e.image_alt_text,
                    loading: "lazy"
                  }
                ),
                ((tile == null ? void 0 : tile.title) || (tile == null ? void 0 : tile.subtitle)) && /* @__PURE__ */ jsxs(TileTextContainer, { children: [
                  (tile == null ? void 0 : tile.title) && /* @__PURE__ */ jsx(
                    TitleText,
                    {
                      color: (text_color == null ? void 0 : text_color.hex) || globalTextColor,
                      children: /* @__PURE__ */ jsx(
                        MarkdownRenderer,
                        {
                          markdown: tile.title,
                          linkColor: (text_color == null ? void 0 : text_color.hex) || globalTextColor
                        }
                      )
                    }
                  ),
                  (tile == null ? void 0 : tile.subtitle) && /* @__PURE__ */ jsx(
                    SubtitleText,
                    {
                      color: (text_color == null ? void 0 : text_color.hex) || globalTextColor,
                      children: /* @__PURE__ */ jsx(
                        MarkdownRenderer,
                        {
                          markdown: tile.subtitle,
                          linkColor: (text_color == null ? void 0 : text_color.hex) || globalTextColor
                        }
                      )
                    }
                  )
                ] })
              ]
            },
            index
          );
        } else {
          return /* @__PURE__ */ jsxs(
            Tile,
            {
              background: background_color == null ? void 0 : background_color.hex,
              borderColor: (_f = tile.border_color) == null ? void 0 : _f.hex,
              color: text_color == null ? void 0 : text_color.hex,
              children: [
                /* @__PURE__ */ jsx(
                  TileImage,
                  {
                    src: (_h = (_g = tile == null ? void 0 : tile.feature_icon.image) == null ? void 0 : _g[0]) == null ? void 0 : _h.url,
                    alt: tile == null ? void 0 : tile.feature_icon.image_alt_text,
                    loading: "lazy"
                  }
                ),
                ((tile == null ? void 0 : tile.title) || (tile == null ? void 0 : tile.subtitle)) && /* @__PURE__ */ jsxs(TileTextContainer, { children: [
                  (tile == null ? void 0 : tile.title) && /* @__PURE__ */ jsx(TitleText, { color: text_color == null ? void 0 : text_color.hex, children: /* @__PURE__ */ jsx(
                    MarkdownRenderer,
                    {
                      markdown: tile.title,
                      linkColor: (text_color == null ? void 0 : text_color.hex) || globalTextColor
                    }
                  ) }),
                  (tile == null ? void 0 : tile.subtitle) && /* @__PURE__ */ jsx(SubtitleText, { color: text_color == null ? void 0 : text_color.hex, children: /* @__PURE__ */ jsx(
                    MarkdownRenderer,
                    {
                      markdown: tile.subtitle,
                      linkColor: (text_color == null ? void 0 : text_color.hex) || globalTextColor
                    }
                  ) })
                ] })
              ]
            },
            index
          );
        }
      })
    }
  );
};
export {
  FeatureTilesSection
};
